import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { withApollo } from "react-apollo";
import { push } from 'connected-react-router';
import { Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';

import ArticleForm from './components/ArticleForm';

import { newsArticleAdded } from './newsActions';
import { CreateArticleMutation } from './queries';
import { prepareCreateArticleRecord } from './articleRecord';
import { parseFormErrors } from '../shared/utils/form_errors';

class EditSourceArticle extends Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(data) {
    const { client, push, newsArticleAdded, idx } = this.props;
    const record = prepareCreateArticleRecord(data);
    return client.mutate({ mutation: CreateArticleMutation, variables: { record } })
      .then(() => newsArticleAdded(idx))
      .then(() => push('/news/sources'))
      .catch(parseFormErrors);
  }

  render() {
    const { item } = this.props;

    return (
      <div id="edit-source-article">
        <Breadcrumb>
          <Breadcrumb.Item><Link to="/news">News</Link></Breadcrumb.Item>
          <Breadcrumb.Item><Link to="/news/sources">Fetch News</Link></Breadcrumb.Item>
          <Breadcrumb.Item>Edit Article</Breadcrumb.Item>
        </Breadcrumb>

        <div className="container">
          <ArticleForm
            initialValues={item}
            onSubmit={this.handleSubmit}
            cancelPath="/news/sources"
          />
        </div>
      </div>
    );
  }
}

export default compose(
  withProps(({ match }) => ({
    idx: +match.params.idx,
  })),
  connect(
    ({ news }, { idx }) => ({
      item: news.articles[idx],
    }),
    { push, newsArticleAdded }
  ),
  withApollo,
)(EditSourceArticle);
